import React, { useContext, useState, useEffect } from 'react';
import _ from "lodash";
import axios from 'axios';
import ENVIRONMENT from '../../../../environments';
import CustomerProductContext from '../../ContextFiles/CustomerProductContext';
import { Button, Menu, Dropdown, Tooltip } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import SiloPhotographyPresetsModal from '../../SiloPhotography/SiloPhotographyPresetsModal';

const { SubMenu } = Menu;

const AssetButtons = (props) => {
    const { product_id, openVariationModal, openVideoModal, productAssetData,
        openDimensionalModal, openThreeSixtyModal, statusOf360Spin, statusOfMp4Video, productData, isAiModel, modelStatus, setAiRefineModalOpen, setAiLifestyleModalOpen, aiInspirationImage, aiInputImage, aiPromptText } = useContext(CustomerProductContext);

    const [openSiloPresetModal, setOpenSiloPresetModal] = useState(false);
    const [selectedPreset, setSelectedPreset] = useState(-1);
    const [allPresets, setAllPresets] = useState([]);

    useEffect(() => {
        fetchProductSiloPresets()
    }, [])

    const gotoSiloPresetModal = () => {
        setOpenSiloPresetModal(true)
    }

    const goToSilo = () => {
        window.location.href = "/silo-tool/" + product_id + "?origin=/products/" + product_id;
    }

    const goToAddLifestyle = () => {
        window.location.href = "/add-lifestyle/" + product_id + "?origin=/products/" + product_id;
    }

    const fetchProductSiloPresets = () => {
        axios.post(ENVIRONMENT.CUSTOMER_SILO_CONFIG, { "username": localStorage.getItem('username'), 'action': 'get_presets' })
            .then(res => {
                if (res.data && res.data.length > 0) {
                    let presets = [];
                    for (let i = 0; i < res.data.length; i++) {
                        if (res.data[i].settings[productData.category] != undefined) {
                            presets.push(res.data[i]);
                        }
                    }
                    setAllPresets(presets);
                }
            })
    }

    const isMenuItemDisabled = () => {
        // if model is an Ai model and the status is 14, 15 or 16, then the item should be disabled
        return [14, 15, 16].includes(modelStatus) && isAiModel
    }

    const hasGlb = () => {
        if (!productAssetData) return false;
        
        const downloadLinks = productAssetData.download_links || [];
        console.log(downloadLinks);
        
        // Check for regular GLB
        const hasRegularGlb = downloadLinks.some(link => link.display_name === 'GLB');
        
        // For AI models, also check for AI GENERATED GLB
        if (isAiModel) {
            const hasAiGlb = downloadLinks.some(link => link.display_name === 'AI GENERATED GLB');
            return hasRegularGlb || hasAiGlb;
        }
        
        return hasRegularGlb;
    }
    const menu_bottom = (
        <Menu style={{ width: "148px" }}>
            {(isAiModel && modelStatus == 16) &&
                <Menu.Item disabled={isMenuItemDisabled()} className='manrope f-14' key={6} onClick={goToAddLifestyle}>
                    <span className='cursor-pointer'>Generate Lifestyle</span>
                </Menu.Item>}
            <SubMenu disabled={isMenuItemDisabled()} className='manrope f-14' title={<span className='manrope f-14'>Generate Silos</span>} popupOffset={[0, 0]}>
                <Menu.Item className='manrope f-14' key={4} onClick={() => goToSilo()} >
                    <span className='cursor-pointer'>From Scratch</span>
                </Menu.Item>
                <Menu.Item disabled={allPresets.length == 0} key={5} onClick={() => gotoSiloPresetModal()} className='manrope f-14'>
                    <span style={allPresets.length == 0 ? { cursor: "not-allowed" } : { cursor: "pointer" }} className='cursor-pointer'>From a Saved Preset</span>
                </Menu.Item>
            </SubMenu>
            <Menu.Item className='manrope f-14' key={0} onClick={openVideoModal} disabled={statusOfMp4Video == "pending" || isMenuItemDisabled()}>
                <Tooltip title={statusOfMp4Video == "pending" ? "We are processing your MP4 Video request at the moment. You’ll be able to request a new MP4 Video once that request is complete. " : ""}>
                    <span className='cursor-pointer'>MP4 Video</span>
                </Tooltip>
            </Menu.Item>
            <Menu.Item disabled={isMenuItemDisabled()} key={1} onClick={openDimensionalModal} className='manrope f-14'>
                <span className='cursor-pointer'>Dimensional Image</span>
            </Menu.Item>
            <Menu.Item className='manrope f-14' key={2} onClick={openThreeSixtyModal} disabled={statusOf360Spin == "pending" || isMenuItemDisabled()}>
                <Tooltip title={statusOf360Spin == "pending" ? "We are processing your 360 Spin request at the moment. You’ll be able to request a new 360 Spin once that request is complete. " : ""}>
                    <span className='cursor-pointer'>Product 360 Spin</span>
                </Tooltip>
            </Menu.Item>
            <Menu.Item disabled={isMenuItemDisabled()} key={3} onClick={openVariationModal} className='manrope f-14'>
                <span className='cursor-pointer'>Product Variant</span>
            </Menu.Item>
        </Menu>
    );


    return (<>
        <div className='ai-action-buttons'>

            {isAiModel && (modelStatus === 14 || modelStatus === 15 || modelStatus === 16) && hasGlb() &&
                <Button onClick={() => setAiRefineModalOpen(true)} className='product-btn dark-blue  f-14 br-4' ghost>
                    Refine This Model
                </Button>
            }
            {isAiModel &&
                <Button onClick={() => {
                    if (modelStatus == 5) {
                        window.location.href = '/ai-asset-creator?stage=lifestyle_generation&productId=' + product_id
                    }
                    if (modelStatus == 16) {
                        window.location.href = `/ai-asset-creator?stage=lifestyle_generation&productId=${product_id}&aiModel=true&img=${aiInputImage}&prompt=${aiPromptText}&imgInspection=${aiInspirationImage}`
                    }

                }} className='generate-ai-btn font-14' ghost>
                    <img src="/img/ai_creator/ai-twinkle.svg" style={{ width: '20px', height: '20px', marginRight: '8px' }} />
                    <span>Generate AI Images</span>
                </Button>
            }

            {/* {!ENVIRONMENT.COMPANY_IDS_WITH_CUSTOM_AI_OUTPUTS.includes(localStorage.getItem("company_id")) &&
                <div  className={`product-btn f-14 br-4 ${(modelStatus === 16) ? "white-bg-text-gradient" : 'ai-gradient'}  ${(modelStatus === 14 || modelStatus === 15) ? 'disabled-ai-btn' : ''}`} 
                        onClick={() => {
                    if (modelStatus==5) {
                        window.location.href = ENVIRONMENT.PORTAL_LINK + 'ai-asset-creator?stage=lifestyle_generation&productId=' + product_id
                    }
                    if (modelStatus == 16) {
                        window.location.href = ENVIRONMENT.PORTAL_LINK + 'ai-asset-creator?stage=lifestyle_generation&productId='+product_id+'&aiModel=true'
                    }
                    
                }}>
                    
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M6.83155 12.2874C7.02678 12.4267 7.26068 12.5015 7.5005 12.5012C7.74032 12.501 7.97408 12.4258 8.16905 12.2862C8.36395 12.1405 8.51209 11.9411 8.5953 11.7124L9.02905 10.3787C9.13309 10.0644 9.3091 9.77886 9.54305 9.5447C9.777 9.31053 10.0624 9.13425 10.3765 9.02992L11.734 8.58867C11.9617 8.50702 12.1579 8.35588 12.295 8.15663C12.4321 7.95738 12.5031 7.72008 12.498 7.47828C12.4929 7.23648 12.4119 7.0024 12.2665 6.80912C12.1212 6.61584 11.9187 6.47313 11.6878 6.40117L10.3516 5.96867C10.0371 5.8648 9.75126 5.68886 9.51687 5.4549C9.28247 5.22094 9.10601 4.93544 9.00155 4.62117L8.5603 3.26617C8.48022 3.04241 8.33278 2.84896 8.13827 2.71242C7.94375 2.57587 7.71171 2.50295 7.47405 2.50367C7.23299 2.50265 6.99771 2.5774 6.80144 2.71736C6.60518 2.85733 6.45786 3.05543 6.3803 3.28367L5.9353 4.64617C5.8308 4.95112 5.65868 5.22849 5.43183 5.45751C5.20497 5.68654 4.92925 5.86128 4.6253 5.96867L3.2703 6.40742C3.04393 6.48742 2.84816 6.63604 2.71027 6.83257C2.57237 7.0291 2.49922 7.26376 2.50101 7.50384C2.5028 7.74392 2.57944 7.97746 2.72024 8.17191C2.86105 8.36637 3.05902 8.51206 3.28655 8.58867L4.6203 9.02242C4.93519 9.12763 5.22125 9.30474 5.4558 9.53972C5.69034 9.7747 5.86693 10.0611 5.97155 10.3762L6.41155 11.7262C6.4903 11.9512 6.6378 12.1474 6.8328 12.2862M5.00905 7.82867L3.9403 7.49742L5.0203 7.14617C5.51353 6.97623 5.96065 6.69427 6.32655 6.32242C6.69155 5.94742 6.96655 5.49742 7.13155 5.00242L7.4628 3.92867L7.8128 5.00617C7.97856 5.50634 8.25913 5.96074 8.63204 6.333C9.00496 6.70526 9.45985 6.98503 9.9603 7.14992L11.0603 7.48617L9.9853 7.83617C9.48444 8.00143 9.02929 8.28178 8.65635 8.65472C8.28341 9.02766 8.00306 9.48282 7.8378 9.98367L7.50655 11.0549L7.1578 9.98117C6.99291 9.47949 6.7126 9.02349 6.33941 8.64986C5.96621 8.27623 5.51054 7.99414 5.00905 7.82867ZM13.1678 17.3137C13.3376 17.4344 13.5408 17.499 13.749 17.4987C13.9589 17.4966 14.163 17.4293 14.333 17.3061C14.5029 17.1829 14.6304 17.01 14.6978 16.8112L15.0078 15.8587C15.074 15.6612 15.1865 15.4799 15.3328 15.3324C15.479 15.1849 15.6603 15.0737 15.8578 15.0087L16.8228 14.6937C17.0224 14.6252 17.1952 14.4954 17.3166 14.3228C17.4379 14.1502 17.5015 13.9436 17.4983 13.7326C17.4951 13.5216 17.4253 13.3171 17.2988 13.1482C17.1723 12.9793 16.9956 12.8548 16.7941 12.7924L15.839 12.4812C15.6416 12.415 15.4621 12.3041 15.3147 12.1571C15.1672 12.0101 15.0558 11.8309 14.989 11.6337L14.6741 10.6662C14.6063 10.4675 14.4777 10.2952 14.3065 10.1736C14.1354 10.0521 13.9303 9.9875 13.7203 9.98902C13.5104 9.99054 13.3063 10.0581 13.1369 10.1821C12.9675 10.3061 12.8414 10.4803 12.7765 10.6799L12.4678 11.6324C12.4041 11.8282 12.2961 12.0067 12.1521 12.1539C12.0082 12.3011 11.8321 12.4131 11.6378 12.4812L10.6678 12.7974C10.521 12.8485 10.3881 12.933 10.2796 13.0444C10.1712 13.1558 10.0902 13.291 10.0432 13.4391C9.99608 13.5873 9.98419 13.7443 10.0084 13.8979C10.0327 14.0514 10.0924 14.1972 10.1828 14.3237C10.3065 14.4987 10.4815 14.6299 10.6828 14.6987L11.6365 15.0074C11.8347 15.0742 12.0146 15.1861 12.1621 15.3342C12.3096 15.4824 12.4206 15.6628 12.4866 15.8612L12.8028 16.8287C12.8713 17.0243 12.9988 17.1937 13.1678 17.3137ZM12.0253 13.8224L11.8028 13.7487L12.0328 13.6687C12.4119 13.5374 12.7556 13.3207 13.0374 13.0352C13.3192 12.7497 13.5315 12.4032 13.6578 12.0224L13.7303 11.7999L13.8053 12.0262C13.9329 12.4093 14.148 12.7574 14.4336 13.0429C14.7191 13.3284 15.0672 13.5436 15.4503 13.6712L15.694 13.7499L15.469 13.8237C15.085 13.9518 14.7362 14.1677 14.4504 14.4544C14.1646 14.7411 13.9497 15.0905 13.8228 15.4749L13.749 15.7012L13.6765 15.4749C13.5503 15.0894 13.3352 14.739 13.0486 14.4519C12.762 14.1649 12.4119 13.9492 12.0266 13.8224" fill={modelStatus == 16 ? "#5a91f7" : 'white'}/>
                    </svg>
                   Generate AI Images
                </div>} */}

            {/* <Button onClick={()=>setAiLifestyleModalOpen(true)} className='product-btn dark-blue f-14 br-4' ghost>
                    Generate AI Lifestyle
                </Button> */}

            {isAiModel == false && modelStatus == 5 &&
                <Button onClick={goToAddLifestyle} className='product-btn white f-14 br-4' ghost>
                    Generate Lifestyle
                </Button>
            }
            {isAiModel == false && <Tooltip title={modelStatus == 16 && isAiModel ? <span className='manrope f-12 white'>Please refine the model before requesting assets</span> : ""}>
                <Dropdown
                    overlay={menu_bottom} trigger={['click']}>
                    <Button style={{ width: "100px" }} className='product-btn white f-14 br-4' ghost>
                        More {props.up ? <UpOutlined /> : <DownOutlined />}
                    </Button>
                </Dropdown>
            </Tooltip>}

        </div>

        <SiloPhotographyPresetsModal id={product_id} openSiloPresetModal={openSiloPresetModal} selectedPreset={selectedPreset} allPresets={allPresets} setSelectedPreset={setSelectedPreset} setOpenSiloPresetModal={setOpenSiloPresetModal} />

    </>
    );
};

export default AssetButtons;